import {
    GET_ALL_SETTINGS,
    ADD_SETTING,
    EDIT_SETTING,
    DELETE_SETTING
} from '../actions/SettingActions'

const initialState = {
    data: [],
    totalPrizes: 0,
    totalPages: 0,
    currentPage: 1,
    latestUpdate: '',
    loading: false,
    error: '',
}

const PrizeReducer = function (state = initialState, action) {
    switch (action.type) {
        case ADD_SETTING: {
            let tempArray = Object.assign({}, state.allPrizes)
            tempArray.rows = [action.payload, ...state.allPrizes.rows]
            return {
                ...state,
                allPrizes: tempArray,
            }
        }
        case EDIT_SETTING: {
            let tempArray = Object.assign({}, state.allPrizes)
            let target = tempArray.rows.findIndex(item => {return item.id == action.payload.id})
            tempArray.rows[target] = action.payload            
            return {
                ...state,
                allPrizes: tempArray,
            }
        }
        case DELETE_SETTING: {
            let tempArray = Object.assign({}, state.allPrizes)
            let newArray = tempArray.rows.filter(item => {return item.id !== action.payload})
            tempArray.rows = newArray            
            return {
                ...state,
                allPrizes: tempArray,
            }
        }
        case GET_ALL_SETTINGS: {
            return {
                ...state,
                data: action.payload.settings.settings,
                currentPage: action.payload.settings.currentPage,
                totalPrizes: action.payload.settings.totalElements,
                totalPages: action.payload.settings.totalPages,
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default PrizeReducer
